import type React from "react";
import { Navigate, useParams } from "react-router";

/**
 * Renders vault subpages, redirecting to the dashboard when a required route param is missing
 */
interface SubpageWrapperProps<P> {
  component: React.ComponentType<P>;
  requireId?: boolean;
  componentProps?: P;
}

const SubpageWrapper = <P extends object>({
  component: Component,
  requireId = true,
  componentProps = {} as P,
}: SubpageWrapperProps<P>) => {
  const params = useParams<{ id?: string; offeringId?: string }>();
  const hasRequiredParam = requireId ? params.id || params.offeringId : true;

  if (!hasRequiredParam) {
    return <Navigate to="/vault/dashboard" replace />;
  }

  return <Component {...componentProps} />;
};

export default SubpageWrapper;
